import { SET_PRIMARY_PARAMETER_LEVEL } from './types';

export const setPrimaryParameterLevel = primaryParameterLevel => ({
  type: SET_PRIMARY_PARAMETER_LEVEL, primaryParameterLevel
});
